<template>
  <div class="loginBox">
    <div class="loginCenter">
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
        <h3 class="title">系统登录</h3>
        <el-form-item prop="account">
          <el-input type="text" v-model="ruleForm2.account"  placeholder="账号"   prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input type="password" v-model="ruleForm2.checkPass"  placeholder="密码"  prefix-icon="el-icon-lock"></el-input>
        </el-form-item>

        <el-form-item   style="margin-bottom: 0;">
          <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
        </el-form-item>

        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
   
    <div class="beian">
      <span>©2021</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        <span>鲁ICP备20020198号</span>
      </a>
      <!-- <span>青岛和诚环保科技有限公司</span> -->
    </div>
  </div>
</template>

<script>
  import { requestLogin } from '../../api/api';
  export default {
    name: 'userlogin',
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true,
      };
          },
    created() {},
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2() {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            this.logining = true;

            var loginParams=new URLSearchParams();
            loginParams.append('userName', this.ruleForm2.account);
            loginParams.append('password', hex_md5(this.ruleForm2.checkPass));

            requestLogin(loginParams).then(data => {
              this.logining = false;
              let resData = data.data;
              if (resData.code !== 200) {
                this.$message({
                  message: "登录失败",
                  type: 'error'
                });
              } else{
                //清空上次遗留的界面标签
                this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {})
                sessionStorage.setItem('token', data.data.data);
                this.$router.push({ path: '/indexPage' });
              }
            }) .catch((res) => {
              this.logining = false;
              this.$message({
                message: "登录失败",
                type: 'error'
              });
            });
          } else {
            return false;
          }
        });
      },
    },
    mounted() {
      var _this=this;
      document.addEventListener('keydown', function(e){
        if (e.keyCode == 13) {
          _this.handleSubmit2();
        }
      });
    },

  }

</script>

<style lang="scss" scoped>
.loginBox{
  width: 100%;
  height: 100%;
  background: url(/static/bg_login.png);
  background-size: 100% 100%;
}
.loginCenter{
  background: url(/static/bg_login_center.png);
  background-size: 100% 100%;
  width: 40%;
  height: 40%;
  margin: 0 auto;
  position: relative;
  top: 30%;
}
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 0 auto;
    width: 50%;
    padding: 35px 35px 15px 35px;
    position: relative;
    left: 25%;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      font-size: 20px;
      color: #3c75ad;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }

   
  }

  .beian{
    position: fixed;
    bottom: 1%;
    right: 1%;
    span{
      display: inline;
      margin-right: 10px;
      color: #dae9fe;
      font-size: 12px;
    }
  }

//验证码样式
  .randomcodeuse{
		width: 70%;
		margin: auto;
		display: flex;
		align-items: center;
	}
	.identifybox {
		display: flex;
		justify-content: space-between;
		margin-top: 0px;
	}
	.iconstyle {
		color: #409EFF;;
	}

</style>


// WEBPACK FOOTER //
// Login.vue?ce8cd6ba